import apiClient from './client';

interface LoginRequest {
  email: string;
  password: string;
}

interface LoginResponse {
  accessToken: string;
  refreshToken: string;
  user: {
    id: string;
    email: string;
    name: string;
    role: string;
    preferences: {
      language: 'he' | 'en';
      timezone: string;
      defaultDateRange: string;
    };
  };
}

interface RefreshResponse {
  accessToken: string;
}

export async function login(data: LoginRequest): Promise<LoginResponse> {
  const response = await apiClient.post<LoginResponse>('/auth/login', data);
  return response.data;
}

export async function refreshToken(token: string): Promise<RefreshResponse> {
  const response = await apiClient.post<RefreshResponse>('/auth/refresh', {
    refreshToken: token,
  });
  return response.data;
}

export async function logout(): Promise<void> {
  await apiClient.post('/auth/logout');
}

export async function getMe() {
  const response = await apiClient.get('/auth/me');
  return response.data.user;
}
